import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import React from "react";
import useV2ChatBotWidget from "../../hooks/useV2ChatBotWidget";
import ChatWidgetView from "../../components/ChatWidgetView";
import { TranslationProvider } from "../../providers/TranslationContext";
import withV2ChatMessageListener from "../../hoc/withV2ChatMessageListener";
import { V2ChatProvider } from "../../providers/v2ChatContext";
import { IndependentBotProvider } from "../../providers/independentBotContext";
import { JobListMapProvider } from "../../providers/JobListMapContext";

// Create a fallback theme to prevent MUI error #9
const fallbackTheme = createTheme();
const V2ChatBotWidget = () => {
  const {
    themeConfig,
    config,
    updateConfig,
    setThemeConfig,
    setConfig,
    handleConfigTheme,
  } = useV2ChatBotWidget();

  const EnhancedChatWidgetView = withV2ChatMessageListener(ChatWidgetView);
  return (
    <ThemeProvider theme={themeConfig || fallbackTheme}>
      <CssBaseline />
      <IndependentBotProvider>
        <TranslationProvider
          config={config}
          setConfig={setConfig}
          isIndependentBot={false}
        >
          <V2ChatProvider
            config={config}
            updateConfig={updateConfig}
            isIndependentBot={false}
          >
            <JobListMapProvider>
              <EnhancedChatWidgetView
                themeConfig={themeConfig}
                config={config}
                setThemeConfig={setThemeConfig}
                setConfig={setConfig}
                handleConfigTheme={handleConfigTheme}
              />
            </JobListMapProvider>
          </V2ChatProvider>
        </TranslationProvider>
      </IndependentBotProvider>
    </ThemeProvider>
  );
};

export default V2ChatBotWidget;
